module.exports = __webpack_public_path__ + "static/img/burnaby2.929696b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/burnaby2.jpg
// module id = 76
// module chunks = 9